import { SortableHandle } from 'react-sortable-hoc';

const SortableItemHandle = SortableHandle(({ children }) => {
  return children;
});

export default SortableItemHandle;
